import { ACTION } from './reducer';

const actions = {
  updateAnyProperty({ reducerDispatch, data }) {
    reducerDispatch({
      type: ACTION.UPDATE_ANY_KEY,
      payload: {
        ...data,
      },
    });
  },
  updateDisplaySaveAndExitModal({ reducerDispatch, displaySaveAndExitModal }) {
    reducerDispatch({
      type: ACTION.UPDATE_DISPLAY_SAVE_AND_EXIT_MODAL,
      payload: {
        displaySaveAndExitModal,
      },
    });
  },
  updateHasConfirmedSaveAndExit({ reducerDispatch, hasConfirmedSaveAndExit }) {
    reducerDispatch({
      type: ACTION.UPDATE_HAS_CONFIRMED_SAVE_AND_EXIT,
      payload: {
        hasConfirmedSaveAndExit,
      },
    });
  },
  updateIsSaveComplete({ reducerDispatch, isSaveComplete }) {
    reducerDispatch({
      type: ACTION.UPDATE_IS_SAVE_COMPLETE,
      payload: {
        isSaveComplete,
      },
    });
  },
  updateIsInModalState({ reducerDispatch, isInModalState }) {
    reducerDispatch({
      type: ACTION.UPDATE_IS_IN_MODAL_STATE,
      payload: {
        isInModalState,
      },
    });
  },
  addFieldDataEntry({ reducerDispatch, entryObj }) {
    reducerDispatch({
      type: ACTION.ADD_FIELD_DATA_ENTRY,
      payload: {
        entryObj,
      },
    });
  },
  clearFieldDataEntry({ reducerDispatch }) {
    reducerDispatch({
      type: ACTION.CLEAR_FIELD_DATA_ENTRY,
    });
  },
  deleteFieldDataEntry({ reducerDispatch, fieldName }) {
    reducerDispatch({
      type: ACTION.DELETE_FIELD_DATA_ENTRY,
      payload: {
        fieldName,
      },
    });
  },
  updateShouldSaveOnBlur({ reducerDispatch, shouldSaveOnBlur }) {
    reducerDispatch({
      type: ACTION.UPDATE_SHOULD_SAVE_ON_BLUR,
      payload: {
        shouldSaveOnBlur,
      },
    });
  },
  updateServerError({ reducerDispatch, serverErrorObj }) {
    reducerDispatch({
      type: ACTION.UPDATE_SERVER_ERROR,
      payload: {
        serverErrorObj,
      },
    });
  },
  removeServerError({ reducerDispatch }) {
    reducerDispatch({
      type: ACTION.REMOVE_SERVER_ERROR,
    });
  },

  // TODO: add clear field error
  updateHasFieldError({ reducerDispatch, hasFieldError }) {
    reducerDispatch({
      type: ACTION.UPDATE_HAS_FIELD_ERROR,
      payload: {
        hasFieldError,
      },
    });
  },
  updateWizardComplete({ reducerDispatch, isWizardComplete }) {
    reducerDispatch({
      type: ACTION.UPDATE_WIZARD_COMPLETE,
      payload: {
        isWizardComplete,
      },
    });
  },
  updateIsPremiumPurchaseModalOpen({ reducerDispatch, isPremiumPurchaseModalOpen }) {
    reducerDispatch({
      type: ACTION.UPDATE_IS_PREMIUM_PURCHASE_MODAL_OPEN,
      payload: {
        isPremiumPurchaseModalOpen,
      },
    });
  },

  updateIsSaveDisabled({ reducerDispatch, isSaveDisabled }) {
    reducerDispatch({
      type: ACTION.UPDATE_IS_SAVE_DISABLED,
      payload: {
        isSaveDisabled,
      },
    });
  },
};

export default actions;
